import React, { useRef, useImperativeHandle, forwardRef } from 'react';
import classnames from 'classnames';

/**
 * @description Accepts a component as a prop and uses component composition
 * in order to allow for different types of element to be rendered on the canvas.
 */
const MapElementBase = (props, ref) => {
    const {
        id,
        onOver,
        onOut,
        isSelected,
        isHovered,
        isDragging,
        x,
        y,
        component: Component,
    } = props;
    const mapElementRef = useRef(null);
    useImperativeHandle(ref, () => mapElementRef.current);
    const className = classnames({
        'map-element': true,
        hover: isHovered,
        drag: isDragging,
        select: isSelected,
    });

    return (
        <g 
            {...props.styles.mapElement}
            ref={mapElementRef}
            id={id}
            onMouseEnter={onOver}
            onFocus={onOver}
            onMouseLeave={onOut}
            className={className}
            transform={`matrix(1,0,0,1,${x},${y})`}
        >
            <Component {...props} />
        </g>
    );
};

export default forwardRef(MapElementBase);
